module.exports = __webpack_public_path__ + "img/md.7e4c0d86.svg";